export default function HifdhGame() {
  return (
    <div className="flex flex-col items-center justify-center text-center">
      <h2 className="text-2xl font-bold">Hifdh Game</h2>
      <p> Test / Memorization game logic</p>
      <p>coming soon...</p>
      

     

    </div>
  );
}
